export default __webpack_public_path__ + "static/media/Armguards of Heroic Soul.f78cdf79.jpg";